import React from 'react';
import Header from '../components/Header';
import HeroArea from '../components/HeroArea';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import WhySaaS from '../components/WhySaaS';
import Features from '../components/Features';
import About from '../components/About';
import CTA from '../components/CTA';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="pt-5">
      {/* <Header /> */}
      <HeroArea />
      <Services />
      <HowItWorks />
      <WhySaaS />
      <Features />
      <About />
      <CTA />
      {/* <Pricing /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
